<template>
  <div class="single-course-area ptb-100" v-if="course">
    <div class="container">
      <div class="row">
        <!-- Course Content -->
        <div class="col-lg-8 col-md-12">
          <div class="single-course-desc">
            <div class="single-course-image">
              <img :src="course.image" :alt="course.title" />
            </div>
            <div class="single-course-content">
              <p class="course-catgy">{{ course.category }}</p>
              <h2>{{ course.title }}</h2>

              <div class="user-details">
                <p><span>Eğitmen :</span> {{ course.instructor.name }}</p>
              </div>
            </div>

            <!-- Tabs -->
            <div class="course-tabs">
              <nav>
                <div class="nav course-nav" id="nav-tab" role="tablist">
                  <button class="course-link active" id="nav-overview-tab" data-bs-toggle="tab"
                    data-bs-target="#nav-overview" type="button" role="tab" aria-controls="nav-overview"
                    aria-selected="true">
                    Genel
                  </button>
                  <button class="course-link" id="nav-carriculum-tab" data-bs-toggle="tab"
                    data-bs-target="#nav-carriculum" type="button" role="tab" aria-controls="nav-carriculum"
                    aria-selected="false">
                    Müfredat
                  </button>
                  <button class="course-link" id="nav-instructor-tab" data-bs-toggle="tab"
                    data-bs-target="#nav-instructor" type="button" role="tab" aria-controls="nav-instructor"
                    aria-selected="false">
                    Eğitmen
                  </button>
                </div>
              </nav>

              <div class="single-course-tab" id="nav-tabContent">
                <!-- Overview -->
                <div class="overview-panel fade active show" id="nav-overview" role="tabpanel"
                  aria-labelledby="nav-overview-tab">
                  <div class="overview-content cmb-30">
                    <h3 class="course-desc-heading">Kurs Açıklaması</h3>
                    <p>{{ course.description }}</p>
                  </div>

                  <!-- What You Will Learn -->
                  <div class="overview-otp cmb-30">
                    <h3 class="course-desc-heading">Ne Öğreneceksiniz?</h3>
                    <div class="row">
                      <div class="col-lg-6 col-md-12 col-sm-12" v-for="(item, index) in course.whatYouWillLearn"
                        :key="index">
                        <div class="course-single-otp">
                          <img src="@/assets/img/icon/ck.svg" alt="icon" />
                          <p>{{ item }}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Extra Facilities -->
                  <div class="overview-extra">
                    <h3 class="course-desc-heading">Ekstra Olanaklar!</h3>
                    <div class="row">
                      <div class="col-lg-4" v-for="(facility, index) in course.extraFacilities" :key="index">
                        <div class="extra-otp">
                          <img :src="facility.icon" alt="icon" />
                          <p>{{ facility.text }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Curriculum -->
                <div class="carriculum-panel fade" id="nav-carriculum" role="tabpanel"
                  aria-labelledby="nav-carriculum-tab">
                  <div class="carriculum-content cmb-30">
                    <h3 class="course-desc-heading">Müfredat</h3>
                    <ul>
                      <li>
                        <p>Seviye: {{ course.level }}</p>
                      </li>
                      <li>
                        <p>{{ course.lessons }} Ders Sayısı/Oturum</p>
                      </li>
                      <li>
                        <p>Toplam Süre: {{ course.duration }}</p>
                      </li>
                    </ul>
                  </div>
                </div>

                <!-- Instructor -->
                <div class="instructor-panel fade" id="nav-instructor" role="tabpanel"
                  aria-labelledby="nav-instructor-tab">
                  <div class="single-instructor-content">
                    <div class="row">
                      <div class="col-lg-5">
                        <div class="instructor-img">
                          <img :src="course.instructor.image" :alt="course.instructor.name" />
                        </div>
                      </div>
                      <div class="col-lg-7">
                        <div class="single-instructor-info">
                          <h2>{{ course.instructor.name }}</h2>
                          <p class="sub-title">{{ course.instructor.title }}</p>
                          <p>{{ course.instructor.bio }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Reviews -->
                <div class="reviews-panel fade" id="nav-reviews" role="tabpanel" aria-labelledby="nav-reviews-tab">
                  <h3>Reviews Section</h3>
                  <!-- statik bırakabilirsin -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Sidebar -->
        <div class="col-lg-4 col-md-12">
          <CourseSidebar :course="course" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useRoute } from "vue-router";
import courses from "@/data/courseData";
import CourseSidebar from "./CourseSidebar.vue";

export default defineComponent({
  name: "CoursesDetails",
  components: { CourseSidebar },
  setup() {
    const route = useRoute();
    const courseId = Number(route.params.id);
    const course = courses.find((c) => c.id === courseId);
    return { course };
  },
});
</script>

<style scoped>
.single-course-image {
  text-align: center;
  margin-bottom: 30px;
}

.single-course-image img {
  width: 100%;
  height: 400px;
  object-fit: cover;
}
</style>
